import Scheduler from './scheduler.component'

export default Scheduler
